interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  icon?: string;
  action?: string;
  align?: 'left' | 'center';
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  icon = 'ri-fire-line',
  action,
  align = 'left',
}: SectionHeadingProps) {
  const centered = align === 'center';

  return (
    <div
      className={`mb-6 flex flex-col gap-4 md:mb-8 md:flex-row md:items-end ${
        centered ? 'md:justify-center' : 'md:justify-between'
      }`}
    >
      <div className={centered ? 'text-center md:mx-auto md:max-w-2xl' : ''}>
        {eyebrow ? (
          <span className="mb-2 inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium tracking-wide text-secondary-900">
            <span className="flex h-3.5 w-3.5 items-center justify-center">
              <i className={`${icon} text-[13px]`}></i>
            </span>
            {eyebrow}
          </span>
        ) : null}
        <h2 className="font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
          <span className="mr-2 inline-block h-5 w-1.5 translate-y-[2px] rounded-full bg-primary-500 md:h-6"></span>
          {title}
        </h2>
        {desc ? (
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">{desc}</p>
        ) : null}
      </div>
      {action ? (
        <button
          type="button"
          className="group inline-flex w-fit cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
        >
          {action}
          <span className="flex h-4 w-4 items-center justify-center transition-transform group-hover:translate-x-0.5">
            <i className="ri-arrow-right-line text-sm"></i>
          </span>
        </button>
      ) : null}
    </div>
  );
}